<template lang="pug">
  div(
    class="import import-excel"
    @click="showList=false"
    v-bind:class="{ dragging: dragInProgress }")
    e-form-modal(
      :showCloseModalBtn="false"
      :showCancelBtn="false"
      :showSaveButton="false"
      )
      div(slot="header")
        template(v-if="$route.meta.showBreadcrumbs")
          e-breadcrumbs
        h1.title
          template Материалы территориальной схемы

      // верстка
      div.body-wrapper
        div(v-if="userCanCreate").body.body-import
          div.col
            div(
              @drag.stop.prevent="onDragEnd"
              @dragover.stop.prevent="onDragStart"
              @dragstart.stop.prevent="onDragStart"
              @dragenter.stop.prevent="onDragStart"
              @dragend.stop.prevent="onDragEnd"
              @dragleave.stop.prevent="onDragEnd"
              @drop.stop.prevent="onFileDrop"
            ).upload-files
              div.upload
                div.upload-content
                  div.icon
                  div.info
                    p.blue Перетащите файлы в эту область
                    p Поддерживаемые форматы - xls,xlsx,doc,docx,pdf,jpg,zip,rar,7z
                  //button.green--text Загрузить
                  div.file-upload
                    label.file-upload__label(for="upload") Загрузить
                    input(
                      type="file" @change="addFile"
                      v-if="enableFileUpload"
                    ).file-upload__input

        e-table(
          :items="items"
          :showEditButton="false"
          :showCheckbox="false"
          :scrollUpdateStreamName="scrollUpdateStreamName"
        )
          template(slot="file_name" slot-scope="props")
            a(
              @click.stop.prevent="downloadFile(props.row)"
            ) {{props.row.file_name}}
          template(v-if="userCanCreate" slot="show_menu", slot-scope="props")
            PublicInput(:fileId="props.row.id" :show="props.row.show_menu")
          template(slot="actionButtons" slot-scope="props")
            div.buttons
              button(
                v-if="userCanDeleteFile(props.row) === true"
                @click="deleteItem(props.row)"
              ).row-delete
</template>

<script>
  import {ROUTE_NAME_TYPE_MAP} from '../../config/import.js'
  import importMixin from '../import/mixins/import-mixin.js'
  import {importEndpoints, publicFiles} from '../../api/api-endpoints.js'
  import PublicInput from "./PublicInput";

  export default {
    mixins: [importMixin],
    components: {
      PublicInput
    },
    name: 'PublicFile',
    computed: {
      supportedFormat() {
        return ['xls', 'xlsx', 'doc', 'docx','jpg','pdf','7z','zip','rar']
      }
    },
    methods: {
      getType(route) {
        let type = null;
        if (route.query && route.query.fromName) {
          let name = route.query.fromName;
          for (let fromName in ROUTE_NAME_TYPE_MAP) {
            if (name === fromName || name.indexOf(fromName) > -1) {
              type = ROUTE_NAME_TYPE_MAP[fromName];
              break
            }
          }
        }
        return type
      },
      setBreadcrumbs () {
        let {location} = this.$router.resolve('');
        let matchedRoute = this.$router.match(location);
        let links = [];
        if (matchedRoute.matched) {
          for (let i = 0; i < matchedRoute.matched.length; i++) {
            let link = matchedRoute.matched[i];
            if (link.meta && link.meta.title) {
              links.push(link)
            }
          }
        } else {
          links.push({name: matchedRoute.name, meta: matchedRoute.meta})
        }
        this.$store.commit('breadcrumbs', {
          name: this.$route.name,
          links: links
        })
      },
      getDownloadTemplateEndpoint(code) {
        return importEndpoints.templateDownload(code)
      },
      getTemplateEndpoint(route, type) {
        return importEndpoints.template(type)
      },
      getEndpoint(route) {
        return publicFiles.files(route)
      },
      getDeleteUrl(id) {
        return publicFiles.file(id)
      },
      deleteItem(item) {
        this.$e.confirmBox(
          'Все занесенные записи будут удалены'
        ).then(() => {
          this.$bar.start();
          this.$store.dispatch('deleteModel', {
            url: this.getDeleteUrl(item.id)
          }).then(() => {
            this.$bar.finish();
            this.reFetchData()
          }).catch(er => {
            this.$bar.finish();
            this.$e.errorBox(er)
          })
        })
      },
      getUploadUrl() {
        return publicFiles.files({})
      },
      getServerQueueEndpoint(id) {
        return importEndpoints.fileToServerQueue(id)
      },
      downloadFile(item) {
        const endpoint = publicFiles.file(item.id);
        this.download(endpoint, item.file_name)
      },
      userCanDeleteFile(item) {
        return this.userCanDelete;
      },
      closeModal() {
        this.showModal = false;
        this.fileId = null;
        this.fileName = null;
      }
    },
    asyncData({store, route, fromRoute, methods, isAutoUpdate = false}) {
      let promises = [];

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getEndpoint(route)
      }));
      return Promise.all(promises)
    }
  }

</script>

<style>
  .import-excel a {
    word-break: break-word !important;
    cursor: pointer !important;
  }
</style>
